import local from './api'

const httpClient = local

export default httpClient